import React from 'react'
import MediaQuery from 'react-responsive'

import FirebaseAuth from '../misc/FirebaseAuth'
import Error from '../misc/Error'
import PageLoading from '../misc/PageLoading'
import AppHeader from '../misc/AppHeader'
import CopyrightInfo from '../misc/CopyrightInfo'
import Onboarding from './Onboarding'
import PersonList from './PersonList'
import {
  Page,
  Footer,
} from '../../styles/layout'
import {
  MobileFooterLink,
} from '../../styles/links'

const Home = ({history}) => (
  <Page>
    <AppHeader />
    <FirebaseAuth>
      { ({isLoading, error, auth}) => {

        if (isLoading) {
          return <PageLoading />
        }

        if (error) {
          return <Error error={error} />
        }

        if (!auth) {
          return <Onboarding />
        }

        return <PersonList auth={auth} history={history} />
      }}
    </FirebaseAuth>

    <Footer>
      <MediaQuery key='desktop' query="(min-width: 500px)">
        <CopyrightInfo />
      </MediaQuery>
      <MediaQuery key='mobile' query="(max-width: 499px)">
        <FirebaseAuth>
          { ({auth}) => {
            return auth &&
            <MobileFooterLink to={`/account`}>
              <ion-icon name="person"></ion-icon>
              account
            </MobileFooterLink>
          }}
        </FirebaseAuth>
      </MediaQuery>
    </Footer>

  </Page>
)

export default Home



// WEBPACK FOOTER //
// ./src/views/people/index.js